// ================================================
// Service Maintenance Page - Frontend Classic
// Displayed when tenant is inactive/permanently inactive
// ================================================

import React, { useEffect, useState } from 'react';

const ServiceMaintenance: React.FC = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }
      `}</style>

      <div className="container position-relative" style={{ zIndex: 10 }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div 
              className="card border-0 shadow-lg"
              style={{
                background: 'white',
                borderRadius: '24px',
                overflow: 'hidden'
              }}
            >
              <div className="card-body p-5 text-center">
                {/* Icon */}
                <div 
                  className="mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: '120px',
                    height: '120px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '50%',
                    animation: 'float 3s ease-in-out infinite',
                    boxShadow: '0 20px 60px rgba(102, 126, 234, 0.4)'
                  }}
                >
                  <svg 
                    width="60" 
                    height="60" 
                    viewBox="0 0 24 24" 
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                </div>

                {/* Title */}
                <h1 
                  className="mb-3"
                  style={{
                    fontSize: '2rem',
                    fontWeight: '700',
                    color: '#1a202c',
                    letterSpacing: '-0.5px'
                  }}
                >
                  ปิดปรับปรุงชั่วคราว
                </h1>

                {/* Subtitle */}
                <p 
                  className="mb-4"
                  style={{
                    fontSize: '1.1rem',
                    color: '#718096',
                    lineHeight: '1.6'
                  }}
                >
                  ระบบอยู่ระหว่างการปรับปรุง{dots}
                </p>

                {/* Divider */}
                <div 
                  className="mx-auto mb-4"
                  style={{
                    width: '50px',
                    height: '3px',
                    background: 'linear-gradient(90deg, #667eea, #764ba2)',
                    borderRadius: '3px'
                  }}
                />

                {/* Message Box */}
                <div 
                  className="p-4 mb-4"
                  style={{
                    background: 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0'
                  }}
                >
                  <p 
                    className="mb-2"
                    style={{
                      fontSize: '1rem',
                      color: '#2d3748',
                      fontWeight: '600',
                      margin: 0
                    }}
                  >
                    ขออภัยในความไม่สะดวก
                  </p>
                  <p 
                    className="mb-0"
                    style={{
                      fontSize: '0.9rem',
                      color: '#718096',
                      margin: 0
                    }}
                  >
                    เรากำลังปรับปรุงระบบเพื่อประสบการณ์ที่ดีขึ้น
                  </p>
                </div>

                {/* Status Indicator */}
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <div
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#48bb78',
                      borderRadius: '50%',
                      animation: 'pulse 2s ease-in-out infinite',
                      boxShadow: '0 0 15px rgba(72, 187, 120, 0.6)'
                    }}
                  />
                  <small style={{ color: '#718096', fontSize: '0.875rem' }}>
                    กำลังดำเนินการปรับปรุงระบบ
                  </small>
                </div>
              </div>

              {/* Footer inside card */}
              <div 
                className="text-center py-3"
                style={{
                  background: '#f7fafc',
                  borderTop: '1px solid #e2e8f0'
                }}
              >
                <small style={{ color: '#a0aec0', fontSize: '0.875rem' }}>
                  © 2024 Huay System
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceMaintenance;

